import {randomString} from '../../helpers/utilities/cryptoStringHelpers';

/* Used to distinguish concurrent app instances in traces/logs. */
export const sessionId = randomString(4);
